import React, {
  FC, useEffect, useState,
} from 'react';
import {
  BackgroundImage,
  Row, Button,
} from './Styles';
import Header from '../../Common/Header';
import LanguageButton from '../../Common/LanguageButton';
import { checkGreen, checkBigGreen } from '../../../../assets/Base64Image';
import { updateFoodifoxData, addFoodifoxLog } from '../../../../lib/axios/FoodifoxDataAPI';
import Logo from '../../Common/Logo';
import RowCenter from '../../../../components/Layout/RowCenter';
import { Ads3pdVO } from '../../../../lib/types';
import { getRandomIntInRange } from '../../../../lib/utils/utils';

const OpenBoxSuccess: FC<Props> = ({
  isEnglish,
  setIsEnglish,
  setShowLoading,
  orderIds,
  boxNumbers,
  completionAdsList,
  deviceCode,
  phoneNumber,
}) => {
  const [reopenBoxLazy, { loading: reopenLoading }] = updateFoodifoxData('/foxH5Take/reopenBoxByOrderId');
  const [selectedAd, setSelectedAd] = useState<Ads3pdVO>();

  useEffect(() => {
    setShowLoading(reopenLoading);

    return () => {
      setShowLoading(false);
    };
  }, [reopenLoading]);

  useEffect(() => {
    if (completionAdsList && completionAdsList.length > 0) {
      const ad = completionAdsList[getRandomIntInRange(0, completionAdsList.length - 1)];
      setSelectedAd(ad);
      if (ad.adId) {
        addFoodifoxLog('foxH5Ads/saveAdsViewLog', {
          deviceCode,
          phoneNumber,
          adId: ad.adId,
        });
      }
    }
  }, []);

  /**
   * 重新开柜门
   */
  const reopenBox = () => {
    Promise.all([
      orderIds.map((orderId) => {
        return new Promise((resolve) => {
          reopenBoxLazy({
            param: {
              orderId,
            },
            onError() {
              resolve(false);
            },
            onCompleted() {
              resolve(false);
            },
          });
        });
      })
    ]).then(([]) => {
      setShowLoading(false);
    });
  };

  return (
    <BackgroundImage>
      {
        selectedAd ? (
          <Row style={{ justifyContent: 'space-between', alignItems: 'center', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto', width: '335px', position: 'relative' }}>
            <div style={{ fontSize: '14px', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 600, color: 'rgb(127, 127, 127)' }}>
              Ad
            </div>
            <LanguageButton isEnglish={isEnglish} setIsEnglish={setIsEnglish} style={{ position: 'absolute', right: -8, marginRight: 0 }} />
          </Row>
        ) : (
          <>
            <Header
              isEnglish={isEnglish}
              setIsEnglish={setIsEnglish}
              style={{ marginTop: '50px' }}
              showSupport={false}
              showHome={false}
              showFAQ={false}
            />

            <Logo showBackIcon={false} style={{ marginTop: '30px' }} />

            {
              isEnglish ? (
                <Row style={{ margin: '43px auto 0 auto', justifyContent: 'center' }}>
                  <img src={checkBigGreen} style={{ width: '25px', height: '25px' }} />
                  <div style={{ fontSize: '22px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '30px', marginLeft: '8px' }}>
                    Successful!
                  </div>
                </Row>
              ) : (
                <div style={{ margin: '43px auto 0 auto', textAlign: 'center', width: '232px', fontSize: '22px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 500, color: '#11202B', lineHeight: '30px' }}>
                  开柜成功!
                </div>
              )
            }
          </>
        )
      }

      {/* HTML5 Completion Banner 广告 */}
      {
        selectedAd && selectedAd.mediaList?.length > 0 && (
          <div
            style={{ width: '335px', margin: '8px auto 0 auto', cursor: 'pointer', borderRadius: 14, overflow: 'hidden' }}
            onClick={() => {
              if (selectedAd.adId) {
                try {
                  addFoodifoxLog('foxH5Ads/saveAdsClickLog', {
                    deviceCode,
                    phoneNumber,
                    adId: selectedAd.adId,
                  });
                } catch (e) {
                }
              }
              if (selectedAd.link && /^(http|https):\/\//.test(selectedAd.link)) {
                window.open(selectedAd.link, '_blank');
              }
            }}
          >
            {
              selectedAd.mediaList[0].mediaType === 'mp4' ? (
                <video
                  muted
                  loop
                  autoPlay
                  playsInline
                  style={{ width: '100%', borderRadius: 14, objectFit: 'contain' }}
                >
                  <source src={selectedAd.mediaList[0].mediaUrl} type="video/mp4" />
                </video>
              ) : (
                <img
                  src={selectedAd.mediaList[0].mediaUrl}
                  alt="ads"
                  style={{ width: '100%', borderRadius: 14, objectFit: 'contain' }}
                />
              )
            }
          </div>
        )
      }

      {/* 重新打开柜门、反馈 */}
      <div style={{ width: '335px', margin: '40px auto 50px auto', padding: '25px 0', textAlign: 'center', background: '#FFFFFF', borderRadius: '20px', border: '1px solid rgba(17,32,43,0.1)' }}>
        {/* 柜门信息 */}
        <RowCenter style={{ flexWrap: 'wrap' }}>
          {
            boxNumbers.map((boxNumber, index) => {
              return (
                <div key={index} style={{ margin: '24px auto 0 auto', width: '142px', height: '68px', background: '#F3F3F3', borderRadius: '12px', textAlign: 'center' }}>
                  <img src={checkGreen} style={{ width: '36px', marginTop: '-18px' }} />
                  {
                    isEnglish ? (
                      <div style={{ marginTop: '8px', fontSize: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '24px' }}>
                        Door #{boxNumber}
                      </div>
                    ) : (
                      <div style={{ marginTop: '8px', fontSize: '18px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '25px' }}>
                        柜门编号 #{boxNumber}
                      </div>
                    )
                  }
                </div>
              );
            })
          }
        </RowCenter>

        {
          isEnglish ? (
            <div style={{ marginTop: 20, fontSize: '16px', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '20px' }}>
              Please take your goods and close door.
            </div>
          ) : (
            <div style={{ marginTop: 20, fontSize: '16px', fontFamily: 'PingFangSC-Medium, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '20px' }}>
              请取走您的物品并关闭柜门
            </div>
          )
        }
      </div>

      <Button
        onClick={() => reopenBox()}
        style={{
          width: 236, height: 66, background: '#01B596', borderRadius: 33, marginTop: '26px', marginLeft: 'auto', marginRight: 'auto',
        }}
      >
        {
          isEnglish ? (
            <div style={{ fontSize: '22px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '29px' }}>
              Reopen the cubicle
            </div>
          ) : (
            <div style={{ fontSize: '22px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '30px' }}>
              重新开柜
            </div>
          )
        }
      </Button>
    </BackgroundImage>
  );
};

export interface Props {
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  orderIds: number[];
  boxNumbers: string[];
  completionAdsList?: Ads3pdVO[];
  deviceCode?: string;
  phoneNumber?: number;
}

export default OpenBoxSuccess;
